var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert"},[_c('div',{staticClass:"alert__container"},[_c('transition',{attrs:{"name":"testing"}},[(_vm.alert.message != '')?_c('div',{staticClass:"alert__main"},[_c('p',{staticClass:"alert__message"},[_vm._v(_vm._s(_vm.alert.message))])]):_vm._e()])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }